import { E_ProcessEnv, getProcessEnv } from '../base/env'
import Agent from '../agent'
import knbUse from '../knb/knb-use'
import { getStatisticUrl } from '../query'
import { mpNavigateTo } from './mp-base'
import { MP_PATH_MAP } from './mp-const'
import { isSupportRN, jump2RN, I_RN_VERSIONS, I_RN_PARAMS } from './rn-base'
import { reportWarn } from '../owl'

export const DOMAIN = {
  IPHX: getProcessEnv(E_ProcessEnv.VUE_APP_DOMAIN_IPHX),
  NEWI: getProcessEnv(E_ProcessEnv.VUE_APP_DOMAIN_PC) || 'https://minsu.dianping.com',
}

export function getIUrl(iPath: string, useIphx = false) {
  return `${useIphx ? DOMAIN.IPHX : DOMAIN.NEWI}${iPath}`
}

export interface I_JUMP2TEMPLATE_METHOD_PARAM {
  useIphx?: boolean
  iPath?: string
  mpPathMap: MP_PATH_MAP
  rnPathConfig: I_RN_PARAMS & {
    versions?: I_RN_VERSIONS
  }
  imeituan?: string
  dianping?: string
  iaphx?: string
}

export function jump2TemplateMethod({
  useIphx,
  iPath,
  mpPathMap,
  rnPathConfig,
  imeituan,
  dianping,
  iaphx,
}: I_JUMP2TEMPLATE_METHOD_PARAM) {
  if (!Agent.native) {
    if (Agent.anyminiprogram) {
      mpNavigateTo(mpPathMap)
      return
    }
    const iUrl = getStatisticUrl(`${useIphx ? DOMAIN.IPHX : DOMAIN.NEWI}${iPath}`)
    if (Agent.pc) {
      window.open(iUrl, '_blank')
      return
    }
    document.location.href = iUrl
    return
  }
  // Native App
  const { versions, mrn_entry, mrn_component, params } = rnPathConfig
  // 优先RN
  if (versions && isSupportRN(versions)) {
    jump2RN({
      mrn_entry,
      mrn_component,
      params,
    })
    return
  }
  if (Agent.meituan && imeituan) {
    knbUse('openPage', {
      url: getStatisticUrl(imeituan),
      query: {
        _knbopeninapp: 1,
      },
    })
    return
  }
  if (Agent.dianping && dianping) {
    knbUse('openPage', {
      url: getStatisticUrl(dianping),
      query: {
        _knbopeninapp: 1,
      },
    })
    return
  }
  if (Agent.phx && iaphx) {
    knbUse('openPage', {
      url: getStatisticUrl(iaphx),
      query: {
        _knbopeninapp: 1,
      },
    })
    return
  }
  reportWarn({
    name: '兜底跳i版',
    msg: rnPathConfig,
  })
  knbUse('openPage', {
    url: getStatisticUrl(`${useIphx ? DOMAIN.IPHX : DOMAIN.NEWI}${iPath}`),
    query: {
      _knbopeninapp: 1,
    },
  })
}
